import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import { SAGA_SIGN_IN } from './actions';

class SignIn extends Component {
  constructor(props){
    super(props);
    this.state = {
        username: '',
        password: '',
    }
    this.inputOnChange = this.inputOnChange.bind(this);
    this.signIn = this.signIn.bind(this);
  }

  inputOnChange(e){
      const tmp = {...this.state};
      tmp[e.target.id] = e.target.value;

      this.setState(tmp);
  }

  signIn(){
      this.props.signIn({
        username: this.state.username,
        password: this.state.password,
      });
  }

  render() {

    return (
      <div>
        <div className="content-area">
          <div className="container">
          <div style={{ width: '50%', float: 'left' }}>
              <h3 className="heading">Sign In</h3>
              <div className="form-field" style={{ width: '100%' }}>
                <label>Username</label>
                <input type="text" placeholder="test@landmarksid.com" value={this.state.username} 
                        id="username" onChange={this.inputOnChange} />
              </div>
              <div className="form-field" style={{ width: '100%' }}>
                <label>Password</label>
                <input placeholder="helloworld" type="password" value={this.state.password} 
                        id="password" onChange={this.inputOnChange} />
              </div>
              <button className="btn btn-blue"
                        style={{ flexGrow: 1, marginLeft: 0 }} 
                        onClick={this.signIn}>Sign In</button>
            </div>
          </div>
          <div style={{ clear: 'both' }} />
        </div>
      </div>
    );
  }
}

SignIn.propTypes = {
  signIn: PropTypes.func,
};

// Map props to the store

const mapStateToProps = () => ({
});

const mapDispatchToProps = (dispatch) => ({
  signIn: (credentials) => {
    dispatch({
      type: SAGA_SIGN_IN,
      payload: {
        credentials,
      },
    });
  },
})

const SignInContainer = connect(mapStateToProps,mapDispatchToProps)(SignIn);

export default SignInContainer;



// WEBPACK FOOTER //
// ./src/Auth/SignIn.js